import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { createSpinner, showSpinner } from '@syncfusion/ej2-angular-popups';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent {

    @Input()  fullOpacity: boolean = false;

    
    constructor() { }

    ngOnInit(): void {
        const loaderElem = document.getElementById('spinner-container') as any;
        createSpinner({ target: loaderElem });
        showSpinner(loaderElem);
    }
}
